import { render, staticRenderFns } from "./abstract.vue?vue&type=template&id=25b52d2a&scoped=true&"
import script from "./abstract.vue?vue&type=script&lang=js&"
export * from "./abstract.vue?vue&type=script&lang=js&"
import style0 from "./abstract.vue?vue&type=style&index=0&id=25b52d2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b52d2a",
  null
  
)

export default component.exports